module.exports = __webpack_public_path__ + "media/icons/plyny-eksploatacyjne-title@2x-7b7c0dae.png";